// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2RfK_","options":"AnswerScale_options__2uBfc","selected":"AnswerScale_selected__1nuN8"};